var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditimagebtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#FB8500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1033_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 10.2499L5.876 9.48345C6.09557 9.29148 6.37987 9.19011 6.67136 9.19986C6.96285 9.20961 7.23975 9.32974 7.446 9.53595L9.591 11.6809C9.75745 11.8474 9.97728 11.9497 10.2118 11.97C10.4463 11.9903 10.6804 11.9273 10.873 11.7919L11.0225 11.6869C11.3003 11.4918 11.6361 11.3967 11.9749 11.4172C12.3138 11.4376 12.6357 11.5724 12.888 11.7994L14.5 13.2499",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5V9.5M12.5 5L14 6.5M12.5 5L11 6.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15 12.357 15 13.5355 14.2675 14.2675C13.536 15 12.357 15 10 15C7.643 15 6.4645 15 5.732 14.2675C5 13.536 5 12.357 5 10C5 9.436 5 8.939 5.01 8.5M10 5C7.643 5 6.4645 5 5.732 5.732C5.52 5.9445 5.369 6.1945 5.262 6.5",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1033_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditimagebtn);
export default __webpack_public_path__ + "static/media/editimagebtn.88dbe18a78035dbdf019aed077e311e3.svg";
export { ForwardRef as ReactComponent };